/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ReportObject } from './ReportObject';
import {
    ReportObjectFromJSON,
    ReportObjectFromJSONTyped,
    ReportObjectToJSON,
} from './ReportObject';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfReportObject
 */
export interface ResultOfReportObject {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfReportObject
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfReportObject
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfReportObject
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfReportObject
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfReportObject
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfReportObject
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfReportObject
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ReportObject}
     * @memberof ResultOfReportObject
     */
    data?: ReportObject;
    /**
     * 
     * @type {number}
     * @memberof ResultOfReportObject
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfReportObject interface.
 */
export function instanceOfResultOfReportObject(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfReportObjectFromJSON(json: any): ResultOfReportObject {
    return ResultOfReportObjectFromJSONTyped(json, false);
}

export function ResultOfReportObjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfReportObject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ReportObjectFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfReportObjectToJSON(value?: ResultOfReportObject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ReportObjectToJSON(value.data),
        'Count': value.count,
    };
}

